import _ from '@lodash';

import { eventPaid, eventFunded, eventNotFunded } from 'app/constants/eventStatus';

const isFunded = event => {
  let folderName = _.get(event, 'loan.loanFolder');
  let milestoneCurrent = _.get(event, 'milestoneCurrent');
  
  // Si tiene milestone "Clear to Close", "Funding", "Post Closing" o "Completion", está funded
  const fundedMilestones = ['Clear to Close', 'Funding', 'Post Closing', 'Completion'];
  const isMilestoneFunded = fundedMilestones.includes(milestoneCurrent);
  
  // Si tiene milestone funded O folder funded O fecha de financiamiento, está funded
  return isMilestoneFunded || folderName === "Closed - Funded" || folderName === "Completed Loans" || !!_.get(event, 'collectedFees.fundDate');
};

//Is Locked Logic??
export const isLocked = event => !!_.get(event, 'projectedFees.yieldSpread');

export const isLoanOfficerPaid = event => {
  //Is Paid Logic
  return event.payments && event.payments.length > 0 && !!event.payments.find(p => !!p.paymentDate); //Original
}

const getEventStatus = event => {
  if (isFunded(event) && isLoanOfficerPaid(event)) {
    return eventPaid;
  }
  return isFunded(event) ? eventFunded : eventNotFunded;
};

const cssClassByEventStatus = {
  [eventPaid]: 'iloan-event-paid',
  [eventFunded]: 'iloan-event-funded',
  [eventNotFunded]: 'iloan-event-not-funded'
};

const getEventStatusCSSClass = event => cssClassByEventStatus[getEventStatus(event)];

export { isFunded, getEventStatus, getEventStatusCSSClass };
